import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import {
  TableGeneralSimpleComponent,
  CardComponent,
  PaginatorComponent,
  ViewToggleComponent,
  CardAction,
  CardItem,
  TicketListStore,
  WorkflowProjectTableItem,
  TICKET_ACCENT_BY_STATUS,
  TICKET_STATUS_CONFIG,
  SORT_FIELDS,
  SORT_DIRECTIONS,
} from '../../../shared';

@Component({
  selector: 'app-tickets',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    TableGeneralSimpleComponent,
    CardComponent,
    PaginatorComponent,
    ViewToggleComponent,
  ],
  templateUrl: './tickets.component.html',
  styleUrl: './tickets.component.css',
})
export class TicketsComponent implements OnInit {
  private store = inject(TicketListStore);
  private router = inject(Router);

  public workflowProjects = this.store.projects;
  public isLoading = this.store.isLoading;
  public pagination = this.store.pagination;

  public dataSource = new MatTableDataSource<WorkflowProjectTableItem>();

  public viewMode = signal<'table' | 'cards'>('table');

  public statusConfig = TICKET_STATUS_CONFIG;
  public accentByStatus = TICKET_ACCENT_BY_STATUS;
  public estatusHighlights = TICKET_STATUS_CONFIG;

  public sortFields = SORT_FIELDS;
  public sortDirections = SORT_DIRECTIONS;
  public sortField = this.store.sortField;
  public sortDirection = this.store.sortDirection;

  public headers = [
    { value: 'id', description: 'ID' },
    { value: 'curp', description: 'CURP' },
    { value: 'direccion', description: 'Dirección' },
    { value: 'odt', description: 'Folio' },
    { value: 'workflow', description: 'Descripción del flujo' },
    { value: 'startDate', description: 'Fecha Inicio' },
    { value: 'status', description: 'Estatus' },
    { value: '', description: 'Acciones' },
  ];
  
  public menuButton = [
    { key: 'visibility', icon: 'visibility', text: '', toolTip: 'Ver' },
  ];

  constructor() {
    effect(() => {
      this.dataSource.data = this.store.projects();
    });
  }

  public getWorkflowProjectItems(item: WorkflowProjectTableItem): CardItem[] {
    return [
      { icon: 'tag', label: 'Folio', value: item.odt },
      { icon: 'workflow', label: 'Descripción del flujo', value: item.workflow },
      { icon: 'phone', label: 'Teléfono', value: item.telefono || 'N/A' },
      { icon: 'location_on', label: 'Dirección', value: item.direccion || 'N/A', row: 3 },
      { icon: 'badge', label: 'CURP', value: item.curp || 'N/A' },
    ];
  }

  public getWorkflowProjectActions(item: WorkflowProjectTableItem): CardAction[] {
    return [
      { icon: 'visibility', label: 'Ver', action: () => this.viewWorkflowProject(item), color: 'primary' },
    ];
  }

  public onEndElement(element: { key: string; element: WorkflowProjectTableItem }): void {
    if (element.key === 'visibility') {
      this.viewWorkflowProject(element.element);
    }
  }

  public viewWorkflowProject(item: WorkflowProjectTableItem): void {
    this.router.navigate(['/ticket', item.odt], { queryParams: { locationKey: item.locationKey } });
  }

  public onPageChange(page: number): void {
    this.pagination.setPage(page);
    this.store.reload();
  }

  public onPageSizeChange(size: number): void {
    this.pagination.setPageSize(size);
    this.store.reload();
  }

  public onSortFieldChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.store.setSortField(value);
  }

  public onSortDirectionChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.store.setSortDirection(value);
  }

  ngOnInit(): void {
    this.store.load();
  }
}
